import React, { useState, useEffect } from "react";
import {
  Avatar,
  Button,
  Card,
  TextField,
  Typography,
  Grid,
  MenuItem,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  updateTherapist,
  uploadTherapistImage,
  uploadTherapistResume,
  changeTherapistPassword,
} from "../../redux/therapistSlice";
import { getBranches } from "../../redux/branchSlice";
import axios from "axios";
import { toast } from "react-toastify";

const TherapistEditPage = () => {
  const therapist = useSelector((state) => state.therapist);
  const dispatch = useDispatch();
  const branches = useSelector((state) => state.branches.branches);
  const [formData, setFormData] = useState({
    name: therapist?.name || "",
    surname: therapist?.surname || "",
    identificationNumber: therapist?.identificationNumber || "",
    contact: {
      countryCode: therapist?.contact?.countryCode || "",
      phoneNumber: therapist?.contact?.phoneNumber || "",
    },
    address: {
      description: therapist?.address?.description || "",
      city: therapist?.address?.city || "",
      town: therapist?.address?.town || "",
      district: therapist?.address?.district || "",
      code: therapist?.address?.code || "",
    },
    profileImage: therapist?.profileImage || "",
    specialty: therapist?.specialty || "",
    documents: [],
    password: "",
    confirmPassword: "",
    description: "",
    oldPassword: "",
  });

  useEffect(() => {
    dispatch(getBranches());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.startsWith("contact.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        contact: { ...prev.contact, [key]: value },
      }));
    } else if (name.startsWith("address.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        address: { ...prev.address, [key]: value },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const resultAction = await dispatch(uploadTherapistImage(file));
      const data = resultAction.payload;

      if (data?.imageUrl) {
        const fileName = data.imageUrl.replace(
          "http://15.236.76.228:8000/uploads/image/",
          ""
        );

        setFormData({
          ...formData,
          profileImage: fileName,
        });

        toast.success("Photo uploaded successfully.");
      } else {
        toast.error("Upload successful but image path not returned.");
      }
    } catch (error) {
      console.error("Photo upload error:", error);
      toast.error("Photo could not be uploaded.");
    }
  };

  const handleResumeUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || file.type !== "application/pdf") {
      toast.error("Please upload a valid PDF file.");
      return;
    }

    try {
      const resultAction = await dispatch(uploadTherapistResume(file));
      const message = resultAction.payload;
      if (message?.includes("success")) {
        toast.success("CV uploaded successfully.");
      } else {
        toast.error("Upload failed.");
      }
    } catch (error) {
      console.error("CV could not be uploaded:", error);
      toast.error("CV could not be uploaded.");
    }
  };

  const handleSave = () => {
    if (formData.password || formData.confirmPassword) {
      if (formData.password !== formData.confirmPassword) {
        toast.error("Passwords do not match!");
        return;
      }

      if (formData.oldPassword === formData.password) {
        toast.error("New password must be different from the old password.");
        return;
      }

      dispatch(
        changeTherapistPassword({
          oldPassword: formData.oldPassword,
          newPassword: formData.password,
          confirmPassword: formData.confirmPassword,
        })
      )
        .unwrap()
        .then((res) => {
          toast.success(res.message || "Password changed successfully.");
          setFormData((prev) => ({
            ...prev,
            oldPassword: "",
            password: "",
            confirmPassword: "",
          }));
        })
        .catch((err) => {
          toast.error(err || "Password change failed.");
        });
    }

    const dataToSend = new FormData();
    dataToSend.append("name", formData.name);
    dataToSend.append("surname", formData.surname);
    dataToSend.append("identificationNumber", formData.identificationNumber);
    dataToSend.append("specialty", formData.specialty);
    if (formData.profileImage) {
      dataToSend.append("profileImage", formData.profileImage);
    }
    if (formData.description) {
      dataToSend.append("description", formData.description);
    }
    dataToSend.append("contact", JSON.stringify(formData.contact));
    dataToSend.append("address", JSON.stringify(formData.address));
    formData.documents.forEach((file, index) => {
      dataToSend.append(`documents[${index}]`, file);
    });

    axios
      .put("/api/therapists/update", dataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        dispatch(updateTherapist(response.data));
        toast.success("Therapist information has been updated.");
      })
      .catch((error) => {
        console.error("Update failed", error);
        // Eğer hata adres alanı ile ilgiliyse sadeleştirilmiş mesaj göster
        if (
          error?.response?.data?.message &&
          (error.response.data.message.includes("address.city") ||
            error.response.data.message.includes("address.town") ||
            error.response.data.message.includes("address.district") ||
            error.response.data.message.includes("address.code"))
        ) {
          toast.error("Please fill in all address information.");
        } else {
          toast.error("Update failed.");
        }
      });
  };

  return (
    <div className="flex justify-center min-h-screen p-4 md:p-12 lg:p-24 font-poppins">
      <Card className="w-full h-full max-w-lg p-6 rounded-2xl shadow-lg bg-white ">
        <h1 className="mb-8 font-poppins text-2xl text-text">
          Therapist Profile Edit
        </h1>
        <div className="flex flex-col items-center mb-4">
          <Avatar
            src={
              formData.profileImage
                ? `http://15.236.76.228:8000/uploads/image/${formData.profileImage}`
                : ""
            }
            className="w-24 h-24 mb-2"
          />
          <div className="flex justify-center">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              id="profile-image-upload"
              className="block text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-green-50 file:text-green-700 hover:file:bg-green-100"
            />
          </div>
        </div>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Surname"
              name="surname"
              value={formData.surname}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Identification Number"
              name="identificationNumber"
              value={formData.identificationNumber}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              select
              label="Specialty"
              name="specialty"
              value={formData.specialty}
              onChange={handleChange}
              fullWidth
            >
              {branches.map((branch) => (
                <MenuItem key={branch._id} value={branch.name}>
                  {branch.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <div style={{ display: "flex", gap: 8 }}>
              <TextField
                select
                label="Country Code"
                name="contact.countryCode"
                value={formData.contact.countryCode}
                onChange={handleChange}
                sx={{ maxWidth: 120 }}
              >
                <MenuItem value="+90">+90 (Türkiye)</MenuItem>
                <MenuItem value="+1">+1 (ABD/Kanada)</MenuItem>
                <MenuItem value="+44">+44 (İngiltere)</MenuItem>
                <MenuItem value="+49">+49 (Almanya)</MenuItem>
                <MenuItem value="+33">+33 (Fransa)</MenuItem>
                <MenuItem value="+39">+39 (İtalya)</MenuItem>
              </TextField>
              <TextField
                label="Phone Number"
                name="contact.phoneNumber"
                value={formData.contact.phoneNumber}
                onChange={handleChange}
                fullWidth
              />
            </div>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="City"
              name="address.city"
              value={formData.address.city}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="District"
              name="address.district"
              value={formData.address.district}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Description"
              name="description"
              multiline
              rows={3}
              value={formData.description}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Old Password"
              name="oldPassword"
              type="password"
              value={formData.oldPassword}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="New Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Confirm Password"
              name="confirmPassword"
              type="password"
              value={formData.confirmPassword}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              className="mt-4 font-medium text-gray-700"
            >
              New Documents (CV, References, etc.)
            </Typography>
            <input
              type="file"
              accept="application/pdf"
              onChange={handleResumeUpload}
              className="w-full border p-2 rounded-md"
            />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          onClick={handleSave}
          fullWidth
          sx={{
            backgroundColor: "#024202",
            "&:hover": { backgroundColor: "#023202" },
            mt: 5,
          }}
        >
          Save
        </Button>
      </Card>
    </div>
  );
};

export default TherapistEditPage;
